/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';

//----------------------------------------------------------------------//
// CSS.                                                                 //
//----------------------------------------------------------------------//

import styles from './ReviewPanel.module.scss';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

type TypeProps = {|
  date: string,
  title: string,
  icon: string,
|};

function ReviewPanel(props: TypeProps): React.StatelessFunctionalComponent<*> {
  const { date, title, icon }: TypeProps = props;

  const classes = `${styles['review-panel']} ${styles[props.extraClass]}`;

  return (
    <div className={classes}>
      <div className={styles['review-icon']}>
        <svg>
          <use xlinkHref={icon} />
        </svg>
      </div>
      <div className={styles['review-text']}>
        <span>{title}</span>
        <span>{date}</span>
      </div>
    </div>
  );
}

// export default observer(ReviewPanel);
export default ReviewPanel;
